import { adGroups } from "../auth/adGroups.data";
import { UserGroup } from "../enums/UserGroup";

export const getUniqueItems = ( items: string[ ] ): string[ ] => items.filter( onlyUnique );

export const formatDate = ( dateTime: Date ): string => new Date( dateTime ).toLocaleDateString( "en-AU" );

export const formatDateTime = ( dateTime: Date ): string =>  
    dateTime ? new Date( dateTime ).toLocaleDateString("en-AU") + ' ' + new Date( dateTime ).toLocaleTimeString( "en-AU" ) : '';

    
export const formatVoltage = ( voltageLevel: number ): string => {

    const voltage = ( voltageLevel / 1000 ).toFixed( 1 );
    const formattedVoltage = `< ${voltage} V`;
    return formattedVoltage;

};


export const addDays = ( days: number ): string => {

    let today = new Date( );
    today.setDate( today.getDate( ) + days );
    return today.toISOString( );

}


export const getDefaultWifiKeyExpiry = ( ) : string => {

    let today = new Date( );
    const day = today.getDate( ) < 10 ? `0${ today.getDate( ) }` : `${ today.getDate( ) }`;
    const month = today.getMonth( ) + 1 < 10 ? `0${ today.getMonth( ) + 1 }` : `${ today.getMonth( ) + 1 }`;
    const year = today.getFullYear( );

    return ( new Date( `${ year }-${ month }-${ day }T23:59:59.000` ) ).toISOString( );

};


export const getOneSecondBeforeMidnight = ( dateString : string ) : string => {

    const date = new Date( dateString );
    const plusOneDay = new Date( date.setDate( date.getDate() + 1 ));
    const minusOneSecond = new Date( plusOneDay.setSeconds( plusOneDay.getSeconds() - 1 ));
    const offset = new Date().getTimezoneOffset();
    const offsetted = new Date( minusOneSecond.setMinutes( minusOneSecond.getMinutes() + offset ));
    return offsetted.toISOString( );

}


export const getSecurityRoleIds = ( userGroups: UserGroup[ ] ): string[ ] => {

    const commonAreaUserGroups: UserGroup[ ] = [
        UserGroup.CommonAreaAccess,
        UserGroup.ESSSupervisor,
        UserGroup.NPIHousing,
        UserGroup.NPIOps,
    ]
    
    const filteredCommonAreaUserGroups = commonAreaUserGroups.filter( value => userGroups.includes( value ) );

    const securityRoleIds: string[ ] = [ ];

    for( const userGroup of filteredCommonAreaUserGroups ){

        securityRoleIds.push( adGroups.find( ag => ag.name === userGroup )?.guid as string );

    }

    return securityRoleIds;

};


export const getTomorrow = ( ) : string => {

    let today = new Date();
    today.setDate( today.getDate() + 1 );
    return today.toISOString().slice( 0, 10 );

};


const onlyUnique = ( value: string, index: number, self: string[] ) => self.indexOf( value ) === index;


export const sleep = ( ms: number ) => new Promise( resolve => setTimeout( resolve, ms ) );


export const sortComparatorDateTimeString = ( a: string, b: string ) => {

    if ( a < b ){
      
        return -1;

    }
    
    if ( a > b ){
      
        return 1;

    }

    return 0;

}